import React, { useEffect, useState } from "react";
import Plot from "react-plotly.js";
import { fetchMarketMovers } from "../api";

function TopMoversChart({ symbol = "NIFTY 200", chartType = "treemap" }) {
  const [plotData, setPlotData] = useState(null);

  useEffect(() => {
    fetchMarketMovers(symbol)
      .then((data) => {
        const stocks = data.stocks;
        console.log(stocks);

        if (chartType === "treemap") {
          setPlotData([
            {
              type: "treemap",
              labels: stocks.map((s) => s.name),
              parents: stocks.map(() => ""),
              values: stocks.map((s) => Math.abs(s.change)),
              marker: {
                colors: stocks.map((s) => s.change),
                colorscale: [
                  [0, "red"],
                  [0.5, "yellow"],
                  [1, "green"],
                ],
                colorbar: { title: "Change (%)" },
              },
              textinfo: "label+value",
              hovertemplate:
                "<b>%{label}</b><br>Change: %{color:.2f}%<extra></extra>",
            },
          ]);
        } else if (chartType === "barchart") {
          // Split top gainers and losers
//          const sorted = [...stocks].sort((a, b) => b.change - a.change);
//          const gainers = sorted.slice(0, 10);
//          const losers = sorted.slice(-10).reverse();
  	    const gainers = stocks.filter(s => s.change >= 0).sort((a, b) => b.change - a.change).slice(0, 10);
            const losers = stocks.filter(s => s.change < 0).sort((a, b) => a.change - b.change).slice(0, 10).reverse();
          setPlotData([
            {
              type: "bar",
              x: gainers.map((g) => g.name),
              y: gainers.map((g) => g.change),
              name: "Top Gainers",
              marker: { color: "green" },
            },
            {
              type: "bar",
              x: losers.map((l) => l.name),
              y: losers.map((l) => l.change),
              name: "Top Losers",
              marker: { color: "red" },
            },
          ]);
        }
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, [symbol, chartType]);

  if (!plotData) return <p>Loading...</p>;

  return (
    <Plot
      data={plotData}
      layout={{
        // title: `Market Movers (${symbol.toUpperCase()}) - ${chartType.toUpperCase()}`,
        title: `Market Movers (${symbol.toUpperCase()})`,
        width: 650,
        height: 500,
        barmode: chartType === "barchart" ? "group" : undefined,
      }}
    />
  );
}

export default TopMoversChart;

